var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1081_39157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2502 11.0827C14.2502 8.39102 16.3085 6.33268 19.0002 6.33268C21.6918 6.33268 23.7502 8.39102 23.7502 11.0827V14.2493H26.9168V11.0827C26.9168 6.64935 23.4335 3.16602 19.0002 3.16602C14.5668 3.16602 11.0835 6.64935 11.0835 11.0827V14.2493H14.2502V11.0827ZM21.3752 22.9577C21.3752 21.691 20.2668 20.5827 19.0002 20.5827C17.7335 20.5827 16.6252 21.691 16.6252 22.9577C16.6252 23.591 16.9418 24.2244 17.4168 24.6994V26.916C17.4168 27.866 18.0502 28.4993 19.0002 28.4993C19.9502 28.4993 20.5835 27.866 20.5835 26.916V24.6994C21.0585 24.2244 21.3752 23.591 21.3752 22.9577Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9168 14.25H11.0835C8.39183 14.25 6.3335 16.3083 6.3335 19V30.0833C6.3335 32.775 8.39183 34.8333 11.0835 34.8333H26.9168C29.6085 34.8333 31.6668 32.775 31.6668 30.0833V19C31.6668 16.3083 29.6085 14.25 26.9168 14.25ZM20.5835 24.7V26.9167C20.5835 27.8667 19.9502 28.5 19.0002 28.5C18.0502 28.5 17.4168 27.8667 17.4168 26.9167V24.7C16.9418 24.225 16.6252 23.5917 16.6252 22.9583C16.6252 21.6917 17.7335 20.5833 19.0002 20.5833C20.2668 20.5833 21.3752 21.6917 21.3752 22.9583C21.3752 23.5917 21.0585 24.225 20.5835 24.7Z",
    fill: "#5A5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1081_39157",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1081_39157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1081_39157",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconWhite);
export default __webpack_public_path__ + "static/media/LockIconWhite.4552a5948c00bb06e4634fb805fddc92.svg";
export { ForwardRef as ReactComponent };